import React from 'react';

const SvgIconZoomIn = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M12.25 3a1 1 0 011 1v6.75H20a1 1 0 011 1v.5a1 1 0 01-1 1h-6.75V20a1 1 0 01-1 1h-.5a1 1 0 01-1-1v-6.75H4a1 1 0 01-1-1v-.5a1 1 0 011-1h6.75V4a1 1 0 011-1z" />
  </svg>
);

export default SvgIconZoomIn;
